import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue"
import _imports_0 from '../assets/per.png'
import _imports_1 from '../assets/psd.png'


const _hoisted_1 = { class: "Login" }
const _hoisted_2 = { class: "LoginBox" }
const _hoisted_3 = { class: "BoxLes" }
const _hoisted_4 = { class: "LesCons" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h1", null, "欢迎登录", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h2", null, [
  /*#__PURE__*/_createElementVNode("span", null, "小盒BOSS后台管理"),
  /*#__PURE__*/_createTextVNode("系统")
], -1)
const _hoisted_7 = { class: "LesForm" }
const _hoisted_8 = { class: "Lis" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "Icon" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  })
], -1)
const _hoisted_10 = { class: "Lis" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "Icon" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: ""
  })
], -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("a", {
  style: {"color":"#175ceb","display":"block","text-align":"center","position":"absolute","bottom":"20px","width":"100%","left":"0"},
  target: "_blank",
  href: "https://www.996w.com/"
}, "联系我们", -1)
const _hoisted_13 = { class: "BoxRis" }
const _hoisted_14 = {
  target: "_blank",
  href: "https://www.996w.com/"
}
const _hoisted_15 = ["src"]
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "AboutUs" }, [
  /*#__PURE__*/_createElementVNode("a", {
    target: "_blank",
    href: "http://www.qqiv.com/"
  }, "腾讯企业邮箱"),
  /*#__PURE__*/_createElementVNode("a", {
    target: "_blank",
    href: "https://www.996w.com/index/Article/index.html?cid=HBzpAtNyE6&visitPower=iykwbepxar"
  }, "网站建设"),
  /*#__PURE__*/_createElementVNode("a", {
    target: "_blank",
    href: "https://www.996w.com/index/Article/index.html?cid=pdrAhixuBz&visitPower=iykwbepxar"
  }, "小程序开发"),
  /*#__PURE__*/_createElementVNode("a", {
    target: "_blank",
    href: "https://www.996w.com/index/Article/index.html?cid=lTGkg6twkC&visitPower=roigaigqdl"
  }, "系统开发"),
  /*#__PURE__*/_createElementVNode("a", {
    target: "_blank",
    href: "https://www.996w.com/index/Article/index.html?cid=kPlJcTcBqM&visitPower=iykwbepxar"
  }, "网站推广"),
  /*#__PURE__*/_createElementVNode("a", {
    target: "_blank",
    href: "https://www.996w.com/index/Articlelist/index.html?cid=iEFrgvpNe4"
  }, "数据安全系统"),
  /*#__PURE__*/_createElementVNode("a", {
    target: "_blank",
    href: "https://www.996w.com"
  }, "联系我们")
], -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "CopyRight" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createTextVNode("版权所有 © 2013-2023 "),
    /*#__PURE__*/_createElementVNode("a", {
      target: "_blank",
      href: "https://www.996w.com"
    }, "广东企拓·九六网"),
    /*#__PURE__*/_createTextVNode(" All rights reserved. "),
    /*#__PURE__*/_createElementVNode("a", {
      target: "_blank",
      href: "https://beian.miit.gov.cn"
    }, "粤ICP备17088737号"),
    /*#__PURE__*/_createTextVNode(" 公司官网："),
    /*#__PURE__*/_createElementVNode("a", {
      target: "_blank",
      href: "https://www.996w.com"
    }, "996w.com"),
    /*#__PURE__*/_createElementVNode("a", { style: {"padding-left":"25px"} }, "联系电话：400-119-0035")
  ])
], -1)

import { reactive, ref } from 'vue'
  import { useAlone } from '@/store';
  import pinia from '@/store/store';
  import {useRouter} from 'vue-router'
  import api from '@/api/index'
  import { ElMessage, ElLoading, FormInstance, FormRules } from 'element-plus'
  
  
export default /*#__PURE__*/_defineComponent({
  __name: 'Login',
  setup(__props) {

  const alone = useAlone(pinia)
  const router = useRouter()
  
  const ruleFormRef = ref<FormInstance>()
  const rules = reactive<FormRules>({
    username: [
      { required: true, message: '请输入用户名', trigger: 'blur' },
    ],
    password: [
      { required: true, message: '请输入密码', trigger: 'blur' },
    ],
  })

  const swiperCons = reactive([
    require("../assets/lb1.jpg"),
    require("../assets/lb2.jpg"),
    require("../assets/lb3.jpg"),
    require("../assets/lb4.jpg")
  ]);
  
  const ruleForm = reactive({
    username:'',
    password:'',
  });
  const login = (formName:any) => {
    const loading = ElLoading.service({
      lock: true,
    })
    api.aloneApi.login(ruleForm).then((res:any) => {
        if (res.code === 200) {
            localStorage.setItem('userId', res.data.id)
            localStorage.setItem('username', ruleForm.username)
            alone.setLoginStatus(true)
            setTimeout(() => {
              router.push("/statistics");
              ElMessage({
                message: res.message,
                type: 'success',
              })
              loading.close()
            }, 1000)
        } else if (res.code == 1002) {
          alone.setLoginStatus(true)
          // 当前已经登录
          router.push({path: '/statistics'})
        }else{
          setTimeout(() => {
            loading.close()
            ElMessage.error(res.message)
          }, 1000)
        }
    }).catch((res:any) => {
      loading.close()
      ElMessage.error(res.message);
    })
  }
  
return (_ctx: any,_cache: any) => {
  const _component_el_carousel_item = _resolveComponent("el-carousel-item")!
  const _component_el_carousel = _resolveComponent("el-carousel")!
  const _component_el_container = _resolveComponent("el-container")!

  return (_openBlock(), _createBlock(_component_el_container, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _hoisted_5,
              _hoisted_6,
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _hoisted_9,
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((ruleForm.username) = $event)),
                    placeholder: "请输入账号"
                  }, null, 512), [
                    [_vModelText, ruleForm.username]
                  ])
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _hoisted_11,
                  _withDirectives(_createElementVNode("input", {
                    type: "password",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((ruleForm.password) = $event)),
                    placeholder: "请输入密码"
                  }, null, 512), [
                    [_vModelText, ruleForm.password]
                  ])
                ])
              ]),
              _createElementVNode("div", {
                class: "Sign",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (login('ruleForm')))
              }, "登录"),
              _hoisted_12
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createVNode(_component_el_carousel, null, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(swiperCons, (item, key) => {
                  return (_openBlock(), _createBlock(_component_el_carousel_item, { key: key }, {
                    default: _withCtx(() => [
                      _createElementVNode("a", _hoisted_14, [
                        _createElementVNode("img", { src: item }, null, 8, _hoisted_15)
                      ])
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ]),
              _: 1
            })
          ])
        ]),
        _hoisted_16,
        _hoisted_17
      ])
    ]),
    _: 1
  }))
}
}

})